var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2014 12.3538V14.5138C16.2022 14.7143 16.1611 14.9128 16.0808 15.0965C16.0005 15.2803 15.8827 15.4452 15.7349 15.5807C15.5871 15.7163 15.4127 15.8195 15.2227 15.8837C15.0328 15.948 14.8315 15.9718 14.6318 15.9538C12.4162 15.7131 10.288 14.956 8.4182 13.7434C6.67856 12.638 5.20364 11.163 4.0982 9.4234C2.88139 7.54506 2.12414 5.40651 1.8878 3.181C1.86981 2.98189 1.89347 2.78123 1.95728 2.59177C2.02109 2.40231 2.12365 2.22821 2.25843 2.08057C2.39321 1.93292 2.55726 1.81495 2.74013 1.73417C2.923 1.6534 3.12069 1.61159 3.3206 1.6114H5.4806C5.83002 1.60796 6.16877 1.73169 6.43371 1.95954C6.69865 2.18739 6.8717 2.5038 6.9206 2.8498C7.01177 3.54105 7.18085 4.21976 7.4246 4.873C7.52147 5.1307 7.54244 5.41078 7.48501 5.68003C7.42759 5.94929 7.29418 6.19644 7.1006 6.3922L6.1862 7.3066C7.21116 9.10915 8.70365 10.6016 10.5062 11.6266L11.4206 10.7122C11.6164 10.5186 11.8635 10.3852 12.1328 10.3278C12.402 10.2704 12.6821 10.2913 12.9398 10.3882C13.593 10.632 14.2718 10.801 14.963 10.8922C15.3128 10.9415 15.6322 11.1177 15.8605 11.3872C16.0888 11.6567 16.2102 12.0007 16.2014 12.3538Z",
    stroke: "#23BA50",
    strokeWidth: 1.008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.cd6486bf0f4dc834a4a49bd1d3fb0ca7.svg";
export { ForwardRef as ReactComponent };